const REVERSED_DESCRIPTION_SUFFIX = " (reversed)";

export function buildReversedPeriodDescription(description: string): string {
    return `${description}${REVERSED_DESCRIPTION_SUFFIX}`;
}
